import { AfterViewChecked, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { appService } from '../../../../../app/_services/app.service';
import { Router } from '@angular/router';
declare var $: any;

@Component({
  selector: 'app-legder-modal',
  templateUrl: './legder-modal.component.html',
  styleUrls: ['./legder-modal.component.scss']
})
export class LegderModalComponent implements OnInit, AfterViewChecked {

  @Input() data: any;
  @Input() isMobileView: any;
  @Output() modifiedValueOutput = new EventEmitter<any>();
  @Output() dataViewCatch = new EventEmitter<any>();
  @Output() onSave = new EventEmitter<any>();
  @Output() onDelete = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<any>();
  @Input() title: any;
  @ViewChild('ledgerDropdown') ledgerDropdown: ElementRef;
  @ViewChild('groupVouchersDropdown') groupVouchersDropdown: ElementRef;
  @ViewChild('ledgerGroupDropdown') ledgerGroupDropdown: ElementRef;
  @ViewChild('ledgerDetailDropdown') ledgerDetailDropdown: ElementRef;
  RouteModeType: any = [];
  LedgerGroup: any;
  GroupAccount: any;
  Account: any;
  LedgerDetail: any;
  IsActive: any;
  ShowInTransportMode: any;
  // ShowinUploadDropdown: any;
  relation: any;
  visible: boolean = false;
  modalRef = '';
  
  constructor(
    private modalService: NgbModal,
    private translate: TranslateService, 
    private _appService: appService,
    private router: Router
  ) { }

  ngOnInit() {
    console.log('title', this.title)
    this.Account = {
      lable: 'Account',
      placeholder: "Account",
      dataField: 'Account',
      formControlName: 'Account',
      isRequired: false,
      isSearchByApi: true,
      typeOfField: 'dropdown',
      isValueBind: true,
    }
    this.GroupAccount = {
      lable: 'Account',
      placeholder: "Account",
      dataField: 'GroupAccount',
      formControlName: 'GroupAccount',
      isRequired: false,
      isSearchByApi: true,
      typeOfField: 'dropdown',
      isValueBind: true,
    }
    this.LedgerGroup = {
      lable: 'Account',
      placeholder: "Account",
      dataField: 'LedgerGroup',
      formControlName: 'LedgerGroup',
      isRequired: false,
      isSearchByApi: true,
      typeOfField: 'dropdown',
      isValueBind: true,
    }
    this.LedgerDetail = {
      lable: 'Account',
      placeholder: "Account",
      dataField: 'LedgerDetail',
      formControlName: 'LedgerDetail',
      isRequired: false,
      isSearchByApi: true,
      typeOfField: 'dropdown',
      isValueBind: true,
    }
    // setTimeout(() => {
    //   $(this.Account.formControlName).focus();
    //   console.log('ho rha h', this.Account.formControlName)
    // }, 100);
  }

  ngAfterViewChecked() {
    // setTimeout(() => {
    //   if (this.title === 'Ledger' && this.ledgerDropdown) {
    //     this.onTab_Ledger()
    //     // this.focusDropdown(this.ledgerDropdown);
    //   } else if (this.title === 'Group Vouchers' && this.groupVouchersDropdown) {
    //     this.focusDropdown(this.groupVouchersDropdown);
    //   } else if (this.title === 'Ledger Group' && this.ledgerGroupDropdown) {
    //     this.focusDropdown(this.ledgerGroupDropdown);
    //   } else if (this.title === 'Ledger Detail' && this.ledgerDetailDropdown) {
    //     this.focusDropdown(this.ledgerDetailDropdown);
    //   }
    // }, 500); // Delay to ensure the view is fully initialized
  }

  focusDropdown(dropdown: ElementRef) {
    if (dropdown && dropdown.nativeElement) {
      dropdown.nativeElement.focus();
    }
  }

  GetAccountList(value, isScrollDown = false) {
    this.Account.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Account.dropdownList.length / 30) + 1;
    }
    this._appService.GetByParamPage('Reporting', 'GetAccountListForJournalEntry', value, pageNo).subscribe(res => {
      res.map((x) => {
        x.name = x.text;
        x.value = x.id;
      });
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Account.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Account.dropdownList);
        this.Account = { ...this.Account, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Account = { ...this.Account, dropdownList: [...dropdownList] });
      this.Account.isSearch = false;
    },
    (error) => {
      this.Account.isSearch = false;
    })
  }

  GetGroupAccountList(value, isScrollDown = false) {
    this.GroupAccount.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.GroupAccount.dropdownList.length / 30) + 1;
    }
    this._appService.GetByParamPage('Reporting', 'GetVoucherAccounts', value, pageNo).subscribe(res => {
      res.map((x) => {
        x.name = x.text;
        x.value = x.id;
      });
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.GroupAccount.dropdownList.length) {
        dropdownList = dropdownList.concat(this.GroupAccount.dropdownList);
        this.GroupAccount = { ...this.GroupAccount, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.GroupAccount = { ...this.GroupAccount, dropdownList: [...dropdownList] });
      this.GroupAccount.isSearch = false;
    },
    (error) => {
      this.GroupAccount.isSearch = false;
    })
  }

  GetLedgerGroupList(value, isScrollDown = false) {
    this.LedgerGroup.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.LedgerGroup.dropdownList.length / 30) + 1;
    }
    this._appService.GetByParamPage('Reporting', 'GetLedgerGroup', value, pageNo).subscribe(res => {
      res.map((x) => {
        x.name = x.text;
        x.value = x.id;
      });
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.LedgerGroup.dropdownList.length) {
        dropdownList = dropdownList.concat(this.LedgerGroup.dropdownList);
        this.LedgerGroup = { ...this.LedgerGroup, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.LedgerGroup = { ...this.LedgerGroup, dropdownList: [...dropdownList] });
      this.LedgerGroup.isSearch = false;
    },
    (error) => {
      this.LedgerGroup.isSearch = false;
    })
  }

  GetLedgerDetail(value, isScrollDown = false) {
    this.LedgerDetail.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.LedgerDetail.dropdownList.length / 30) + 1;
    }
    this._appService.GetByParamPage('Reporting', 'GetLedgerDetails', value, pageNo).subscribe(res => {
      res.map((x) => {
        x.name = x.text;
        x.value = x.id;
      });
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.LedgerDetail.dropdownList.length) {
        dropdownList = dropdownList.concat(this.LedgerDetail.dropdownList);
        this.LedgerDetail = { ...this.LedgerDetail, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.LedgerDetail = { ...this.LedgerDetail, dropdownList: [...dropdownList] });
      this.LedgerDetail.isSearch = false;
    },
    (error) => {
      this.LedgerDetail.isSearch = false;
    })
  }

  getChangedValue(value, data) {
    console.log('value', value)
    if (value != null) {
      this.close();
      if(data == 'Account'){
        // window.location.href = 'main-report?id=' + value.value + '&type=Month';
        this.router.navigateByUrl('main-report?id=' + value.value + '&type=Month');
      }

      if(data == 'GroupAccount'){
        // window.location.href = 'main-report?id=' + value.value + '&type=GroupVouchers';
        this.router.navigateByUrl('main-report?id=' + value.value + '&type=GroupVouchers');
      }

      if(data == 'LedgerGroup'){
        // window.location.href = 'main-report?id=' + value.value + '&type=' + value.name;
        this.router.navigateByUrl('main-report?id=' + value.value + '&type=GroupVouchers');
      }

      if(data == 'LedgerDetail'){
        // window.location.href = 'report-details?id=' + value.CompanyId + '&type=OutstandingLedgerSetoff&account=' + value.name;
        this.router.navigateByUrl('report-details?id=' + value.CompanyId + '&type=OutstandingLedgerSetoff&account=' + value.name);
      }
    }
  }

  onTab_Ledger(){
    setTimeout(() => {
      $("#" + this.Account.formControlName).focus();
    }, 100);
  }

  close() {
    this.title = ''
    this.onClose.emit();
    this.modalRef = null;
  }

  onSaveBtnClick() {
    console.log('this.data', this.data)
    this.onSave.emit(this.data);
    this.onClose.emit();
  }

}
